angular.module('env.services', [
    'env.services.barcodeScannerListener',
    'env.services.fileService',
    'env.services.colorService'
])
;
